module.exports = __webpack_public_path__ + "static/media/discord_full.22c6d08a1ee6e6d0c81bcb39a9c89ed6.svg";